export default __webpack_public_path__ + "SmileySad.9ded16f0.svg";